module.exports = __webpack_public_path__ + "30f05d0dbf6ca2b80c94fd8290bdf341.png";